export interface ResearcherProfileActivation {
    activationStatus: EsploroPersonPortalFieldTypes;
    hasActiveProfileWithNoAssets: boolean;
    publicProfileUrl: string;
    hasActiveProfileWithAssets: boolean;
}

export enum EsploroPersonPortalFieldTypes {
    TRUE = 'true',
    FALSE = 'false',
    DISPLAY_NO_ASSETS = 'displayNoAssets',
    RESEARCHER_REQUESTED_ACTIVATION = 'researcherRequested',
    REFUSED = 'refused'
}



